'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDate = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redial = require('redial');

var _reactRedux = require('react-redux');

var _glamor = require('glamor');

var _components = require('components');

var _Section = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Section');

var _Section2 = _interopRequireDefault(_Section);

var _Hero = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _DescriptionWith3Columns = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns');

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _ItemWithImageDescriptionAndIcons = require('@quixeltools/quixel-ui-library/dist/components/common/website/ItemWithImageDescriptionAndIcons');

var _ItemWithImageDescriptionAndIcons2 = _interopRequireDefault(_ItemWithImageDescriptionAndIcons);

var _news = require('redux/modules/news');

var _utils = require('utils');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _cloudFront = require('../../utils/cloudFront');

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString('en-us', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

var cloudfront = function cloudfront(path) {
  return 'https://d3uwib8iif8w1p.cloudfront.net/megascans/' + path;
};
var cf = function cf(path) {
  return 'https://d3uwib8iif8w1p.cloudfront.net/megascans/' + path;
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return 'https://cdn.quixel.com/quixel/thumbs/' + path;
};
var cloudfrontImages = function cloudfrontImages(path) {
  return 'https://d3uwib8iif8w1p.cloudfront.net/quixel/' + path;
};

var linkDetails = 'https://megascans.zendesk.com/hc/en-us/sections/360000107578-Quixel-Indie-Program-FAQs';

var application = [{
  img: cf('indie/houdiniBackground.jpg'),
  title: 'Houdini',
  description: 'Houdini’s procedural workflow helps you build bigger, richer worlds faster, even with smaller teams and limited resources. SideFX is sponsoring free Houdini Indie licenses especially for developers on this program.',
  icon: cf('misc/houdini.png'),
  secondaryLink: '/mixer',
  primaryLink: '',
  primaryLabel: '',
  // secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  newWindow: true,
  linkLable: 'Learn More',
  link: 'https://www.sidefx.com/products/houdini-indie/',
  Indie: true
}, {
  img: cf('indie/Indie_SpeedTree_Image.png'),
  title: 'SpeedTree',
  description: 'SpeedTree provides industry-leading 3D tree renderings and foliage for gaming, film, and architectural visualization. SpeedTree is sponsoring free Indie modeler licenses especially for developers on this program.',
  icon: cf('indie/Indie_SpeedTree_Logo.png'),
  secondaryLink: '/mixer',
  primaryLink: '',
  primaryLabel: '',
  //  secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  newWindow: true,
  linkLable: 'Learn More',
  link: 'https://store.speedtree.com/',
  Indie: true

}, {
  img: cf('indie/Indie_AMD_Image.png'),
  title: 'AMD',
  description: 'AMD drives innovation in high-performance computing, graphics and visualization tech for gaming and immersive platforms. As a hardware partner, AMD helps eligible program members push the boundaries of what is possible.',
  icon: cf('indie/Indie_AMD_Logo.png'),
  secondaryLink: '',
  primaryLink: '',
  primaryLabel: '',
  //  secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  newWindow: true,
  linkLable: 'Learn More',
  link: 'https://www.amd.com/en/gaming/products',
  Indie: true

}, {
  img: cf('indie/kanasBackground.jpg'),
  title: 'Goodbye Kansas Game Invest',
  description: 'Goodbye Kansas Game Invest enables talented developers by empowering them with wisdom, funding, and a shared passion for games. If you’re a gaming visionary, get an intro to Goodbye Kansas.',
  icon: cf('misc/kanasGames.png'),
  secondaryLink: '/mixer',
  primaryLink: '',
  primaryLabel: '',
  //  secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows and macOS',
  newWindow: true,
  linkLable: 'Learn More',
  link: 'http://goodbyekansasgameinvest.com/',
  Indie: true

}, {
  img: cf('indie/coffeeStainBack.jpg'),
  title: 'Coffee Stain Publishing',
  description: 'Coffee Stain Publishing has one simple mission: Enabling unique games live up to their full potential. Coffee Stain’s extensive game knowledge and data driven marketing expertise can help you reach millions of players.',
  icon: cf('misc/coffeeStain.png'),
  secondaryLink: '/bridge',
  primaryLink: '',
  primaryLabel: '',
  // secondaryLabel: 'Learn More',
  // mobileDownloadText: 'Available for Windows, macOS and linux',
  newWindow: true,

  linkLable: 'Learn More',
  link: 'https://www.coffeestainpublishing.com/',
  Indie: true

}];

var Indie = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Indie, _React$Component);

  function Indie(props) {
    (0, _classCallCheck3.default)(this, Indie);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Indie.__proto__ || (0, _getPrototypeOf2.default)(Indie)).call(this, props));

    _this.state = {
      platform: 'Windows'
    };
    _this.handleClick = _this.handleClick.bind(_this);

    return _this;
  }

  (0, _createClass3.default)(Indie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.context.dialogs.custom(_react2.default.createElement(_components.IndieProgramPopupContainer, {
        title: "Join the Indie Program!",
        description: "Leave us a note and we'll get back to you soon.",
        tag: "indie-program",
        initialValues: { name: '', email: '', studio: '', title: '', url: '', artworkUrl: '', subject: 'Indie Program Application', comments: '', checkBoxPc: '', checkBoxSmartPhone: '', checkBoxPlayStation: '', checkBoxXbox: '', checkBoxNitendo: '', checkBoxMac: '', checkBoxVr: '', checkBoxOther: '', select: '', teamSize: '', releaseDate: '', checkBoxFunding: '', checkBoxPublisher: '' }
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var platform = this.state.platform;


      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: 'Indie Program', documentDescription: 'The Quixel Indie Program gives you access to a complete ecosystem to build, fund, and publish your game. ' },
        _react2.default.createElement(
          'div',
          { className: (0, _glamor.css)({ background: '#0c0c0c', width: '100%' }) },
          _react2.default.createElement(_Hero2.default, {
            bg: '/images/apps/backgroundHeader.jpg',
            superIconUrls: [cloudfront('misc/indieQuixel.png')],
            title: 'The complete ecosystem to build, <br/> fund, and publish your game',
            subTitle: '',
            primaryLabel: '',
            primaryTo: "",
            secondaryLabel: 'APPLY NOW',
            secondaryTo: "/",
            link: {
              label: "Learn More",
              href: linkDetails,
              target: '_blank'
            },
            onClickSecondaryHandler: this.handleClick
          }),
          _react2.default.createElement(
            'div',
            { className: (0, _glamor.css)({ backgroundColor: '#121212', paddingBottom: '20rem' }) },
            _react2.default.createElement(_DescriptionWith3Columns2.default, {
              title: 'WHAT IS IT',
              headingBeforeBreak: 'Get everything you need immediately.',
              headingAfterBreak: 'Pay 2.5% when you succeed.',
              columns: [{
                img: '/images/apps/Megascans.png',
                isIcon: true,
                title: 'Megascans',
                desc: 'Megascans is a massive online scan library of high-resolution PBR-calibrated surface, vegetation and 3D scans.',
                alignLeft: true
              }, {
                img: 'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png',
                isIcon: true,
                title: 'Bridge',
                desc: 'Bridge connects Megascans to all your favorite tools. Browse, manage, and export asstes, straight from your desktop.',
                alignLeft: true
              }, {
                img: '/icons/mixer_icon_2048_preview.png',
                isIcon: true,
                title: 'Mixer',
                desc: 'Simple and easy material creation. Create photorealistic, tileable, materials in seconds with powerful mixing and painting.',
                alignLeft: true
              }]
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _glamor.css)({ marginTop: '-23rem' }) },
            _react2.default.createElement(_Section2.default, {
              innerClassName: (0, _glamor.css)({ maxWidth: '100%' }),
              subHeading: 'PARTNERS',
              content: application.map(function (app) {
                return _react2.default.createElement(_ItemWithImageDescriptionAndIcons2.default, app);
              })
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _glamor.css)({ backgroundColor: '#121212' }) },
            _react2.default.createElement(_DescriptionWith3Columns2.default, {
              title: 'SUPPORT & MARKETING',
              headingBeforeBreak: 'We\u2019ll be with you on the way!',
              hr: true,
              formattedFooter: '<div style="font-size: 1rem">The Quixel Indie Program gives you full access to our entire tool suite including Megascans, Mixer and Bridge, full access to our partners that help you build, fund, and publish your project, as well as our extended technical support and dedicated marketing services. All of this with no upfront cost in exchange for 2.5% of your future revenue.&nbsp;\n                          <a href=\'https://megascans.zendesk.com/hc/en-us/sections/360000107578-Quixel-Indie-Program-FAQs\' target="_blank" style=\'text-decoration: none;color: #808080\'>Learn the details here.</a>\n                        </div>',
              columns: [{
                img: '/images/apps/Megascans.png',
                isIcon: false,
                title: 'Extended support.',
                desc: 'All-access pass to our knowledge base and our super helpful technical artists.<br/><br/>In-depth tutorials, training sessions, tips, tricks, and advice.'
              }, {
                img: '/icons/mixer_icon_2048_preview.png',
                isIcon: false,
                title: 'Helping you shine.',
                desc: 'Reviews on your promotional content and feedback cycles to help you craft your message to the world.'
              }, {
                img: '/images/apps/bridgeIcon.png',
                isIcon: false,
                title: 'Works with your tools.',
                desc: 'Megascans assets are stardardized to work in all your favorite tools, and our apps integrate with all major real-time engines, modeling apps, and renderers.'
              }]
            })
          ),
          _react2.default.createElement(_components.ContactSection, {
            mode: 'dark',
            subHeading: 'MORE WAYS TO BUILD',
            title: 'Want to go out on your own?',
            subTitle: 'If you\u2019d prefer a regular license instead, you can opt for a multi seat Business plan, or each team member may purchase a Personal plan if your funds raised or annual revenue is less than $100K.',
            primaryLabel: 'BUY PERSONAL',
            primaryTo: '/choose/personal',
            secondaryLabel: 'BUY BUSINESS',
            secondaryTo: '/choose/business'
          }),
          _react2.default.createElement(_Hero2.default, {
            bg: '/images/apps/indieBackgroundBottom.jpg',
            superIconUrls: [cloudfront('misc/indieQuixel.png')],
            title: 'Join the program!',
            subTitle: 'Apply now to get access to our amazing set of tools, partners and benefits, and realize your vision today.',
            primaryLabel: '',
            primaryTo: "",
            secondaryLabel: 'APPLY NOW',
            secondaryTo: "/",
            link: {
              label: "Learn More",
              href: linkDetails,
              target: '_blank'
            },
            onClickSecondaryHandler: this.handleClick
          })
        )
      );
    }
  }]);
  return Indie;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _news.loadNews)(1, 2));
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    news: state.news,
    loaded: state.loaded
  };
})(Indie));


//////////////////
// WEBPACK FOOTER
// ./src/pages/Indie/Indie.jsx
// module id = 2617
// module chunks = 0